import { IBaseAudioContext } from './base-audio-context';
import { ICommonOfflineAudioContext } from './common-offline-audio-context';

export interface IOfflineAudioContext extends IBaseAudioContext<IOfflineAudioContext>, ICommonOfflineAudioContext {
    // @todo oncomplete
}
